<main class="mdl-layout__content">
  <section>
    <!--<div id="ritab"
      class="k-widget k-tabstrip k-floatwrap k-tabstrip-top k-header">
      <ul class="k-reset k-tabstrip-items" >
        <li class="k-item k-state-default k-state-disabled">
          <span class="k-link"></span>
        </li>
        <li id="{{product.id}}"
          class="k-item k-state-default"
          routerLinkActive="k-state-active"
          *ngFor="let product of productRouteInfo">
          <a class="k-link"
            routerLinkActive="active"
            [routerLink]="[product.path]">{{product.text}}</a>
        </li>
      </ul>
    </div>-->
    <app-gray-bar-header
      id="ritab"
      [linkList]="productRouteInfo"></app-gray-bar-header>
    <router-outlet></router-outlet>
  </section>
</main>
